import { useTranslation } from 'react-i18next';
import {
    IconButton,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import './TitleBar.scss';

/**
 * @param {{
 * onClose: () => void,
 * }} param0
 */
function TitleBar({ onClose }) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'manager.bidProfileEdit.bidDashboard.publishProgress' });
    return (
        <div className="titleBar--root">
            <div className="titleBar--content">
                <IconButton
                    className="titleBar-x-icon-button"
                    onClick={() => onClose()}
                >
                    <FontAwesomeIcon
                        // @ts-ignore
                        icon={faTimes}
                        size="sm"
                    />
                </IconButton>
                <span className="text-lg-semibold">
                    {t('header')}
                </span>
            </div>

        </div>
    );
}

export default TitleBar;
